import { ConfirmationModal } from 'modules/ui';
import { HTTP_SESSION_EXPIRATION_NONE } from 'modules/messaginghub/MessagingHubServiceHttp';
import { ToastType } from 'modules/application/misc/ToastService';
import { isNullOrWhiteSpace, isPrintableASCII } from 'data/string';
import { ConfigurationFeatures } from '../ConfigurationFeatures';
export class ApiController {
    static $inject = ['ApplicationService2', 'HostingService', 'ChatbotSettingsService', 'LoadingService', 'ConfigurationsSegmentService', 'ModalService', 'BlipToastService', '$translate', 'application', 'TenantService', 'MessagingHubServiceHttp', 'MESSAGINGHUBHTTPHOSTNAME', 'MESSAGINGHUBHTTPHOSTNAMETENANT', 'MESSAGINGHUBWEBSOCKETHOSTNAME', 'MESSAGINGHUBWEBSOCKETHOSTNAMETENANT', 'MESSAGINGHUBTCPHOSTNAME', 'MESSAGINGHUBTCPHOSTNAMETENANT', '$timeout', 'AiAgentService'];
    constructor(ApplicationService2, HostingService, ChatbotSettingsService, LoadingService, ConfigurationsSegmentService, ModalService, BlipToastService, $translate, application, TenantService, MessagingHubServiceHttp, MESSAGINGHUBHTTPHOSTNAME, MESSAGINGHUBHTTPHOSTNAMETENANT, MESSAGINGHUBWEBSOCKETHOSTNAME, MESSAGINGHUBWEBSOCKETHOSTNAMETENANT, MESSAGINGHUBTCPHOSTNAME, MESSAGINGHUBTCPHOSTNAMETENANT, $timeout, AiAgentService) {
        'ngInject';
        this.ApplicationService2 = ApplicationService2;
        this.HostingService = HostingService;
        this.ChatbotSettingsService = ChatbotSettingsService;
        this.LoadingService = LoadingService;
        this.ConfigurationsSegmentService = ConfigurationsSegmentService;
        this.ModalService = ModalService;
        this.BlipToastService = BlipToastService;
        this.$translate = $translate;
        this.application = application;
        this.TenantService = TenantService;
        this.MessagingHubServiceHttp = MessagingHubServiceHttp;
        this.MESSAGINGHUBHTTPHOSTNAME = MESSAGINGHUBHTTPHOSTNAME;
        this.MESSAGINGHUBHTTPHOSTNAMETENANT = MESSAGINGHUBHTTPHOSTNAMETENANT;
        this.MESSAGINGHUBWEBSOCKETHOSTNAME = MESSAGINGHUBWEBSOCKETHOSTNAME;
        this.MESSAGINGHUBWEBSOCKETHOSTNAMETENANT = MESSAGINGHUBWEBSOCKETHOSTNAMETENANT;
        this.MESSAGINGHUBTCPHOSTNAME = MESSAGINGHUBTCPHOSTNAME;
        this.MESSAGINGHUBTCPHOSTNAMETENANT = MESSAGINGHUBTCPHOSTNAMETENANT;
        this.$timeout = $timeout;
        this.AiAgentService = AiAgentService;
        this.isAiAgent = false;
        this.errorInputForm = {
            errorMessagesUrl: '',
            errorNotificationsUrl: '',
            errorOauthAuthorizationServerUri: '',
            errorOAuthClientId: '',
            errorClientSecret: '',
            errorAccessKeySdk: '',
        };
        this.isCheckedOAuth = false;
        this.editClientSecret = () => {
            this.enabledComponentClientSecret(false, true);
            this.oldOAuthClientSecret = this.oAuthClientSecret;
            this.oAuthClientSecret = '';
        };
        this.saveClientSecret = () => {
            this.showMessages();
            if (this.validations.isClientSecretValid) {
                this.enabledComponentClientSecret(true, false);
                this.oldOAuthClientSecret = this.oAuthClientSecret;
            }
        };
        this.cancelClientSecret = () => {
            this.oAuthClientSecret = this.oldOAuthClientSecret;
            this.oldOAuthClientSecret = '';
            this.enabledComponentClientSecret(true, false);
            this.showMessages();
        };
        this.enabledComponentClientSecret = (enable, blockField) => {
            const saveClientSecret = document.getElementById('saveClientSecret');
            const cancelClientSecret = document.getElementById('cancelClientSecret');
            const editClientSecret = document.getElementById('editClientSecret');
            const clientSecret = document.getElementById('oAuthClientSecret');
            const clientId = document.getElementById('oAuthClientId');
            const authorizationServerUri = document.getElementById('oAuthAuthorizationServerUri');
            const urlReceiveNotifications = document.getElementById('urlReceiveNotifications');
            const urlReceiveMessages = document.getElementById('urlReceiveMessages');
            const oAuthEnabled = document.getElementById('oauth-enabled');
            saveClientSecret.hidden = enable;
            cancelClientSecret.hidden = enable;
            editClientSecret.hidden = isNullOrWhiteSpace(this.oAuthClientSecret) || !enable;
            clientSecret.setAttribute('disabled', !editClientSecret.hidden ? 'true' : 'false');
            clientSecret.setAttribute('disabled', !editClientSecret.hidden ? 'true' : 'false');
            clientSecret.setAttribute('open-eyes', 'false');
            clientId.setAttribute('disabled', blockField ? 'true' : 'false');
            authorizationServerUri.setAttribute('disabled', blockField ? 'true' : 'false');
            urlReceiveNotifications.setAttribute('disabled', blockField ? 'true' : 'false');
            urlReceiveMessages.setAttribute('disabled', blockField ? 'true' : 'false');
            oAuthEnabled.setAttribute('disabled', blockField ? 'true' : 'false');
        };
        this.onToggleOAuth = async (event) => {
            this.isCheckedOAuth = await event.detail.checked;
            if (this.receiveMessagesUrl == '' && this.receiveNotificationsUrl == '') {
                return;
            }
            if (!this.isCheckedOAuth) {
                this.deleteOauth();
            }
            else if (this.isCheckedOAuth) {
                this.oAuthClientId = this.oldHttpTarget.oAuthClientId;
                this.oAuthClientSecret = this.oldHttpTarget.oAuthClientSecret;
                this.oAuthAuthorizationServerUri = this.oldHttpTarget.oAuthAuthorizationServerUri;
                this.enabledComponentClientSecret(true, false);
            }
        };
        this.showMessages = () => {
            const errorClientID = this.errorOAuthClientId;
            const errorClientSecret = this.errorClientSecret;
            const errorMsg = this.apiFieldErrorMessages;
            this.errorInputForm.errorOauthAuthorizationServerUri = '';
            this.errorInputForm.errorOAuthClientId = '';
            this.errorInputForm.errorClientSecret = '';
            this.validateHttpFormState();
            if (!this.validations.isOauthAuthorizationServerUriValid) {
                this.errorInputForm.errorOauthAuthorizationServerUri = errorMsg;
            }
            if (!this.validations.isOAuthClientIdValid) {
                this.errorInputForm.errorOAuthClientId = errorClientID;
            }
            if (!this.validations.isClientSecretValid) {
                this.errorInputForm.errorClientSecret = errorClientSecret;
            }
        };
        this.onChangeReceiveMessages = (event) => {
            const { detail: { value } } = event;
            this.receiveMessagesUrl = value;
        };
        this.onChangeReceiveNotificationsUrl = (event) => {
            const { detail: { value } } = event;
            this.receiveNotificationsUrl = value;
        };
        this.onBlurVerifyReceiveUrls = (_) => {
            const errorMsg = this.apiFieldErrorMessages;
            this.errorInputForm.errorMessagesUrl = '';
            this.errorInputForm.errorNotificationsUrl = '';
            this.validateHttpFormState();
            if (!this.validations.isMessagesUrlValid) {
                this.errorInputForm.errorMessagesUrl = errorMsg;
            }
            if (!this.validations.isNotificationsUrlValid) {
                this.errorInputForm.errorNotificationsUrl = errorMsg;
            }
            this.deleteOauthWithChangeUrls();
        };
        this.onChangeAccessKeySdk = (event) => {
            const { detail: { value } } = event;
            this.accessKeySdk = value;
        };
        this.onBlurVerifyAccessKeySdk = (_) => {
            const errorMsg = this.errorAccessKeySdkMessage;
            this.errorInputForm.errorAccessKeySdk = '';
            this.validateHttpFormState();
            if (!this.validations.isAccessKeySdkValid) {
                this.errorInputForm.errorAccessKeySdk = errorMsg;
            }
        };
        this.onChangeOAuthAuthorizationServerUri = (event) => {
            const { detail: { value } } = event;
            this.oAuthAuthorizationServerUri = value;
        };
        this.onChangeOAuthGrantType = (event) => {
            const { detail: { value } } = event;
            this.oAuthGrantType = value;
        };
        this.onChangeOAuthClientId = (event) => {
            const { detail: { value } } = event;
            this.oAuthClientId = value;
        };
        this.onChangeClientSecret = (event) => {
            const { detail: { value } } = event;
            this.oAuthClientSecret = value;
        };
        this.onBlurVerifyOAuth = (_) => {
            this.showMessages();
        };
    }
    async $onInit() {
        this.validations = new HttpValidations();
        this.errorInputForm.errorMessagesUrl = '';
        this.errorInputForm.errorNotificationsUrl = '';
        this.errorInputForm.errorOauthAuthorizationServerUri = '';
        this.errorInputForm.errorOAuthClientId = '';
        this.errorInputForm.errorClientSecret = '';
        this.errorInputForm.errorAccessKeySdk = '';
        const baseUri = this.TenantService.addTenantPrefixToUrl(`https://${this.MESSAGINGHUBHTTPHOSTNAMETENANT}`, this.application?.tenantId, `https://${this.MESSAGINGHUBHTTPHOSTNAME}`);
        this.isTokenManagementEnable = await ConfigurationFeatures.isTokenManagementEnable();
        this.isHideAccessKeyEnabled = await ConfigurationFeatures.hideBotAccessKeyEnabled();
        // Update the base HTTP URI which may contain the tenant prefix
        this.MessagingHubServiceHttp.baseUri = baseUri.substring(0, baseUri.length - 1);
        this.wsHostName = this.TenantService.addTenantPrefixToUrl(this.MESSAGINGHUBWEBSOCKETHOSTNAMETENANT, this.application?.tenantId, this.MESSAGINGHUBWEBSOCKETHOSTNAME);
        this.tcpHostName = this.TenantService.addTenantPrefixToUrl(this.MESSAGINGHUBTCPHOSTNAMETENANT, this.application?.tenantId, this.MESSAGINGHUBTCPHOSTNAME);
        this.isHttpActive = false;
        // Http settings
        if (!this.isTokenManagementEnable) {
            this.authHeaderValue = this.ApplicationService2.getAuthHeaderValue(this.application);
        }
        this.sendMessagesUrl = `${baseUri}messages`;
        this.sendNotificationsUrl = `${baseUri}notifications`;
        this.sendCommandsUrl = `${baseUri}commands`;
        this.ConfigurationsSegmentService.setApplication(this.application);
        this.LoadingService.startLoading();
        this.apiFieldErrorMessages = this.$translate.instant('apiValues.errors.invalidNetworkAddress');
        this.errorOAuthClientId = this.$translate.instant('apiValues.errors.errorOAuthClientId');
        this.errorClientSecret = this.$translate.instant('apiValues.errors.errorClientSecret');
        this.errorAccessKeySdkMessage = this.$translate.instant('apiValues.errors.errorAccessKeySdk');
        this.isAiAgent = await this.AiAgentService.checkAiAgentAsync();
        try {
            this.isBuilderActive = await this.ChatbotSettingsService.isBuilderActive(this.application);
            this.isHttpActive = await this.ChatbotSettingsService.isHttpActive(this.application);
            if (this.isHttpActive) {
                await this.loadHttpConfiguration();
                this.validateHttpFormState();
                this.$timeout(this.bindHeaderValidation.bind(this), 150);
            }
            this.isSdkActive = !this.isBuilderActive && !this.isHttpActive;
        }
        catch (e) {
            this.BlipToastService.show(ToastType.Danger, {
                title: await this.$translate('utils.errorMsg.3'),
                msg: await this.$translate('utils.errorMsg.3'),
            });
            console.error(e);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    bindHeaderValidation() {
        const isValidHttpHeaderKey = (str) => isPrintableASCII(str) && !str.includes(' ');
        const isValidHttpHeaderValue = (str) => isPrintableASCII(str) && !isNullOrWhiteSpace(str);
        this.$timeout(() => {
            const keyValuesForm = this.httpForm['$ctrl.keyValueForm'];
            if (this.receiveEnvelopesHeaders && keyValuesForm) {
                let i = 0, currentForm;
                while ((currentForm = keyValuesForm['form' + i++]) !== undefined) {
                    if (!currentForm.key.$validators.validHeaderKey && !currentForm.value.$validators.validHeaderValue) {
                        currentForm.key.$validators.validHeaderKey = isValidHttpHeaderKey;
                        currentForm.value.$validators.validHeaderValue = isValidHttpHeaderValue;
                    }
                }
            }
        });
    }
    async loadHttpConfiguration() {
        try {
            const [session, httpTarget] = await this.MessagingHubServiceHttp.getTwoWayHttpSession(this.application);
            this.receiveMessagesUrl = httpTarget.messageUrl;
            this.receiveNotificationsUrl = httpTarget.notificationUrl;
            this.oAuthAuthorizationServerUri = httpTarget.oAuthAuthorizationServerUri;
            if (!isNullOrWhiteSpace(this.oAuthAuthorizationServerUri)) {
                this.isCheckedOAuth = true;
            }
            this.oAuthGrantType = httpTarget.oAuthGrantType;
            this.oAuthClientId = httpTarget.oAuthClientId;
            this.oAuthClientSecret = httpTarget.oAuthClientSecret;
            this.oldOAuthClientSecret = this.oAuthClientSecret;
            this.receiveEnvelopesHeaders = httpTarget.messageHeaders || {};
            this.hidingOAuthSecret = httpTarget.hidingOAuthSecret;
            this.enabledComponentClientSecret(true, false);
            this.oldHttpTarget = httpTarget;
        }
        catch (e) {
            console.warn('Error loading HTTP configuration', e);
        }
    }
    async showCopiedToast() {
        this.BlipToastService.show(ToastType.Success, {
            title: await this.$translate('utils.successMsg.30'),
            msg: await this.$translate('utils.successMsg.30'),
        });
    }
    async activateTemplateType(type, active) {
        try {
            this.LoadingService.startLoading();
            switch (type) {
                case 'builder':
                    if (active && !await this.confirmConnectionChange()) {
                        this.isBuilderActive = false;
                        return;
                    }
                    await this.setBuilderActive(active);
                    this.trackConnectionBuilderToggled(active);
                    break;
                case 'http':
                    if (active && !await this.confirmConnectionChange()) {
                        this.isHttpActive = false;
                        return;
                    }
                    await this.setHttpActive(active);
                    this.trackConnectionHTTPToggled(active);
                    break;
                case 'sdk':
                    if (active && !await this.confirmConnectionChange()) {
                        this.isSdkActive = false;
                        return;
                    }
                    await this.setSdkActive(active);
                    this.trackConnectionSDKToggled(active);
                    break;
                default:
                    break;
            }
            this.BlipToastService.show(ToastType.Success, {
                title: await this.$translate('utils.successMsg.8'),
                msg: await this.$translate('utils.successMsg.8'),
            });
        }
        catch (e) {
            this.BlipToastService.show(ToastType.Danger, {
                title: await this.$translate('utils.errorMsg.4'),
                msg: await this.$translate('utils.errorMsg.4'),
            });
            console.error(e);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async setBuilderActive(active, deactivateHttp = true) {
        if (!active) {
            try {
                this.HostingService.unpublish(this.application);
            }
            catch (e) {
                try {
                    const error = JSON.parse(e);
                    if (error.reason.code != 67) {
                        throw e;
                    }
                }
                catch (err) { }
                // Ignore if the application unpublishing fails
            }
        }
        await this.ChatbotSettingsService.setBuilderActive(this.application, active);
        this.isBuilderActive = active;
        if (active) {
            this.isSdkActive = false;
        }
        if (active && deactivateHttp) {
            await this.setHttpActive(false, false);
        }
    }
    async setHttpActive(active, deactivateBuilder = true) {
        if (!active) {
            try {
                await this.unpublishHttp();
                this.receiveMessagesUrl = '';
                this.receiveNotificationsUrl = '';
                this.receiveEnvelopesHeaders = '';
                this.oAuthAuthorizationServerUri = '';
                this.oAuthClientId = '';
                this.oAuthClientSecret = '';
                this.oldHttpTarget = '';
                this.accessKeySdk = '';
            }
            catch (e) {
                try {
                    const error = JSON.parse(e);
                    if (error.reason.code != 67) {
                        throw e;
                    }
                }
                catch (err) { }
                // Ignore if the application unpublishing fails
            }
        }
        else {
            this.receiveEnvelopesHeaders = {};
        }
        await this.ChatbotSettingsService.setHttpActive(this.application, active);
        this.isHttpActive = active;
        if (active) {
            this.isSdkActive = false;
            this.validateHttpFormState();
        }
        if (active && deactivateBuilder) {
            await this.setBuilderActive(false, false);
        }
    }
    async unpublishHttp() {
        await this.MessagingHubServiceHttp.closeHttpSession(this.application);
    }
    async setSdkActive(active) {
        if (active) {
            await this.setBuilderActive(false, false);
            await this.setHttpActive(false, false);
        }
        this.isSdkActive = active;
    }
    async publishHttp() {
        this.LoadingService.startLoading();
        try {
            if (!this.receiveMessagesUrl || this.receiveMessagesUrl == '') {
                this.BlipToastService.show(ToastType.Danger, {
                    title: await this.$translate('utils.errorMsg.4'),
                    msg: await this.$translate('utils.errorMsg.4'),
                });
                return;
            }
            await this.publishHttpTransport();
            this.BlipToastService.show(ToastType.Success, {
                title: await this.$translate('utils.successMsg.8'),
                msg: await this.$translate('utils.successMsg.8'),
            });
        }
        catch (e) {
            let msgError = 'utils.errorMsg.4';
            if (e.code == 13) {
                msgError = 'apiValues.errors.errorAccessKeySdk';
            }
            this.BlipToastService.show(ToastType.Danger, {
                title: await this.$translate(msgError),
                msg: await this.$translate(msgError),
            });
            console.error(e);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async publishHttpTransport() {
        const changeSensitiveData = this.oAuthClientSecret !== this.oldHttpTarget?.oAuthClientSecret;
        const httpTarget = {
            messageUrl: this.receiveMessagesUrl,
            notificationUrl: this.receiveNotificationsUrl,
            oAuthAuthorizationServerUri: this.oAuthAuthorizationServerUri,
            oAuthGrantType: this.oAuthGrantType,
            oAuthClientId: this.oAuthClientId,
            oAuthClientSecret: changeSensitiveData ? this.oAuthClientSecret : undefined,
            commandUrl: undefined,
            messageHeaders: this.receiveEnvelopesHeaders,
            notificationHeaders: this.receiveEnvelopesHeaders,
            commandHeaders: undefined,
            expiration: HTTP_SESSION_EXPIRATION_NONE,
            httpSessionId: isNullOrWhiteSpace(this.oldHttpTarget?.httpSessionId) ? undefined : this.oldHttpTarget?.httpSessionId,
            hidingOAuthSecret: this.hidingOAuthSecret,
        };
        const copyApplication = { ...this.application };
        if (this.isTokenManagementEnable) {
            copyApplication.accessKey = this.accessKeySdk;
        }
        await this.MessagingHubServiceHttp.createHttpSession(copyApplication, httpTarget);
        await this.loadHttpConfiguration();
    }
    async confirmConnectionChange() {
        const modalTitle = await this.$translate('modules.application.detail.templates.api.warning');
        const modalBody = await this.$translate('modules.application.detail.templates.api.changeConnectionDisclaimer');
        const yes = await this.$translate('utils.misc.yes');
        const no = await this.$translate('utils.misc.no');
        const modal = await this.ModalService.showModal(ConfirmationModal({
            title: {
                text: modalTitle,
            },
            body: modalBody,
            buttons: {
                confirm: {
                    text: yes,
                },
                cancel: {
                    text: no,
                },
            },
        }));
        return await modal.close;
    }
    deleteOauthWithChangeUrls() {
        if (this.isCheckedOAuth
            && this.oldHttpTarget.oAuthAuthorizationServerUri === this.oAuthAuthorizationServerUri
            && this.oldHttpTarget.oAuthClientSecret === this.oAuthClientSecret
            && this.oldHttpTarget.oAuthClientId === this.oAuthClientId
            && (this.oldHttpTarget.messageUrl !== this.receiveMessagesUrl
                || this.oldHttpTarget.notificationUrl !== this.receiveNotificationsUrl)) {
            this.deleteOauth();
            this.isCheckedOAuth = false;
        }
    }
    isAnyUrlEmpty() {
        return isNullOrWhiteSpace(this.receiveMessagesUrl) || isNullOrWhiteSpace(this.receiveNotificationsUrl);
    }
    async deleteOauth() {
        this.oAuthAuthorizationServerUri = '';
        this.oAuthClientId = '';
        this.oAuthClientSecret = '';
        this.errorInputForm.errorOAuthClientId = '';
        this.errorInputForm.errorClientSecret = '';
        this.validateHttpFormState();
        this.oldHttpTarget = '';
        this.enabledComponentClientSecret(true, false);
    }
    validateHttpFormState() {
        this.validations.validateReceiveUrlsState(this.receiveMessagesUrl, this.receiveNotificationsUrl);
        this.validations.validateOAuthState(this.oAuthAuthorizationServerUri, this.oAuthClientId, this.oAuthClientSecret);
        if (this.isTokenManagementEnable) {
            this.validations.validateAccessKeySdkState(this.accessKeySdk);
        }
    }
    // Segment
    trackConnectionBuilderToggled(status) {
        this.ConfigurationsSegmentService.trackConnectionBuilderToggled({
            Status: status ? 'enabled' : 'disabled',
        });
    }
    trackConnectionSDKToggled(status) {
        this.ConfigurationsSegmentService.trackConnectionSDKToggled({
            Status: status ? 'enabled' : 'disabled',
        });
    }
    trackConnectionHTTPToggled(status) {
        this.ConfigurationsSegmentService.trackConnectionHTTPToggled({
            Status: status ? 'enabled' : 'disabled',
        });
    }
}
ApiController.$inject = ['ApplicationService2', 'HostingService', 'ChatbotSettingsService', 'LoadingService', 'ConfigurationsSegmentService', 'ModalService', 'BlipToastService', '$translate', 'application', 'TenantService', 'MessagingHubServiceHttp', 'MESSAGINGHUBHTTPHOSTNAME', 'MESSAGINGHUBHTTPHOSTNAMETENANT', 'MESSAGINGHUBWEBSOCKETHOSTNAME', 'MESSAGINGHUBWEBSOCKETHOSTNAMETENANT', 'MESSAGINGHUBTCPHOSTNAME', 'MESSAGINGHUBTCPHOSTNAMETENANT', '$timeout', 'AiAgentService'];
class HttpValidations {
    get isValidHttpForm() {
        return this.isMessagesUrlValid && this.isNotificationsUrlValid
            && this.isOauthAuthorizationServerUriValid && this.isOAuthClientIdValid && this.isClientSecretValid
            && this.isReceiveUrlsValidState && this.isOAuthClientIdValid && this.isAccessKeySdkValid;
    }
    constructor() {
        this.isMessagesUrlValid = true;
        this.isNotificationsUrlValid = true;
        this.isOauthAuthorizationServerUriValid = true;
        this.isOAuthClientIdValid = true;
        this.isClientSecretValid = true;
        this.isReceiveUrlsValidState = true;
        this.isOAuthValidState = true;
        this.isAccessKeySdkValid = true;
    }
    validateReceiveUrlsState(receiveMessagesUrl, receiveNotificationsUrl) {
        this.isMessagesUrlValid = true;
        this.isNotificationsUrlValid = true;
        this.isReceiveUrlsValidState = !isNullOrWhiteSpace(receiveMessagesUrl);
        if (!this.isWebSite(receiveMessagesUrl)) {
            this.isMessagesUrlValid = false;
        }
        if (this.isReceiveUrlsValidState && !this.isUrlEmptyOrValid(receiveNotificationsUrl)) {
            this.isNotificationsUrlValid = false;
        }
    }
    validateOAuthState(oAuthAuthorizationServerUri, oAuthClientId, oAuthClientSecret) {
        this.isOauthAuthorizationServerUriValid = true;
        this.isOAuthClientIdValid = true;
        this.isClientSecretValid = true;
        this.isOAuthValidState = !isNullOrWhiteSpace(oAuthAuthorizationServerUri)
            || !isNullOrWhiteSpace(oAuthClientId)
            || !isNullOrWhiteSpace(oAuthClientSecret);
        if (this.isOAuthValidState && !this.isWebSite(oAuthAuthorizationServerUri)) {
            this.isOauthAuthorizationServerUriValid = false;
        }
        if (this.isOAuthValidState && !oAuthClientId) {
            this.isOAuthClientIdValid = false;
        }
        if (this.isOAuthValidState && !oAuthClientSecret) {
            this.isClientSecretValid = false;
        }
    }
    validateAccessKeySdkState(accessKeySdk) {
        this.isAccessKeySdkValid = !isNullOrWhiteSpace(accessKeySdk);
    }
    isUrlEmptyOrValid(website) {
        if (!website) {
            return true;
        }
        return this.isWebSite(website);
    }
    isWebSite(website) {
        const urlPattern = /^(https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/;
        return urlPattern.test(String(website).toLowerCase());
    }
}
